import React from 'react';
import { useSelector } from 'react-redux';
import { getPitchFxState } from './store/selectors/getPitchFx';
import PitchFx from './PitchFx';
import pitchFxReducer from './store/reducers/pitchFx';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import PropTypes from 'prop-types';
import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';
import uniformsDataRequestAction from './store/actions/uniformsDataRequestAction';
import uniforms from '@gameday/core/datasources/uniforms';
import uniformsReducer from './store/reducers/uniforms';

const FALLBACK_CONFIG = {};

const fetchData = () => {
    return uniformsDataRequestAction();
};

initContainerData.register({
    datasources: {
        uniforms
    },
    reducers: {
        pitchfx: pitchFxReducer,
        uniforms: uniformsReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const PitchFxDataContainer = ({
    pitchFxConfig = FALLBACK_CONFIG,
    viewType
}
) => {
    const pitchfxState = useSelector(getPitchFxState);

    return (
        <ErrorBoundaryWrapper componentName="Strikezone">
            <PitchFx
                {...pitchfxState}
                pitchFxConfig={pitchFxConfig}
                viewType={viewType}
            />
        </ErrorBoundaryWrapper>
    );
};

PitchFxDataContainer.propTypes = {
    pitchFxConfig: PropTypes.object,
    viewType: PropTypes.string
};

export default PitchFxDataContainer;
export { fetchData, routes };
